import { OnBoardingTask } from '../user/types';

export enum TasksActionTypes {
  GET_TASKS = 'GET_TASKS',
  GET_TASKS_SUCCESS = 'GET_TASKS_SUCCESS',
  GET_TASKS_ERROR = 'GET_TASKS_ERROR',
  MARK_DONE_TASK = 'MARK_DONE_TASK',
  MARK_UNDONE_TASK = 'MARK_UNDONE_TASK',
  SET_TASKS_SUCCESS = 'SET_TASKS_SUCCESS',
  TRACK_COPY_LINK_TASK = 'TRACK_COPY_LINK_TASK',
}

export interface TasksState {
  items: OnBoardingTask[];
  loading: boolean;
  loaded: boolean;
  error?: string;
}

interface GetTasks {
  type: typeof TasksActionTypes.GET_TASKS;
}

interface GetTasksSuccess {
  type: typeof TasksActionTypes.GET_TASKS_SUCCESS;
  payload: OnBoardingTask[];
}

interface GetTasksError {
  type: typeof TasksActionTypes.GET_TASKS_ERROR;
  error: string;
}

interface MarkDoneTask {
  type: typeof TasksActionTypes.MARK_DONE_TASK;
  payload: OnBoardingTask;
}

interface MarkUndoneTask {
  type: typeof TasksActionTypes.MARK_UNDONE_TASK;
  payload: OnBoardingTask;
}

export interface TaskListGrouped {
  category: string;
  tasksList: OnBoardingTask['fields'][];
}

interface SetTasksSuccess {
  type: typeof TasksActionTypes.SET_TASKS_SUCCESS;
  payload: OnBoardingTask[];
}

interface TrackCopyLinkTask {
  type: typeof TasksActionTypes.TRACK_COPY_LINK_TASK;
}

export type TasksActions =
  | GetTasks
  | GetTasksSuccess
  | GetTasksError
  | MarkDoneTask
  | MarkUndoneTask
  | SetTasksSuccess
  | TrackCopyLinkTask;
